export default __webpack_public_path__ + "static/Minigun-776c5f83204aa06cf0136a931506533a.png";